import { IOrganization } from "@/api";
import { Button } from "@/components/shared/buttons/Button";
import { useOrganizationProxy } from "@/hooks/useOrganizationProxy";

interface IProps {
    /**
     * The organization to view all compare in charts for
     */
    organization: IOrganization;
}

/**
 * A button to view all compare in charts for an organization
 */
export const ViewAllCompareInChartsButton = ({ organization }: IProps) => {
    const { proxyIntoOrganization, isPending } = useOrganizationProxy({
        navigationPath: "/organizations/comparisons",
    });

    return (
        <Button
            variant="contained"
            color={"inherit"}
            sx={{ borderRadius: 29 }}
            onClick={() => proxyIntoOrganization(organization.id)}
            loading={isPending}
            disableElevation
        >
            View All
        </Button>
    );
};
